import MathHtml from 'components/imported-assessment/MathHtml'
import update from 'immutability-helper'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import Checkbox from '@mui/material/Checkbox'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

const useStyles = makeStyles(multipleChoiceStyles)

export default function MultipleChoice ({context, question}) {

  const classes = useStyles()
  const {translate} = context
  const {properties} = question
  const {choices = []} = question.answer

  const Choices = question.properties.singleOption ? RadioChoice : CheckboxChoice

  return (
    <Box className={classes.root}>
      {choices.length > 0 && (
        <Choices
          question={question}
          context={context} 
          choices={choices}
        />)}
    </Box>
  )
}

function RadioChoice ({context, choices}) {

  const classes = useStyles()
  const correctChoice = choices.find(c => c.correct) || {}
  return (
    <RadioGroup className={clsx("choices", "radio")} value={correctChoice.id || ''}>
      {choices.map((choice, index) => {
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
        return (
          <Box key={index} className={classes.option}>
            <Box className={classes.radio}>
              <FormControlLabel
                value={choice.id}
                className="choice"
                control={<Radio color="primary" />}
                label={(
                  <Box className={classes.optionLabel}>
                    <Box className="index">{answerIndex})</Box>
                    {context.importedMath ? <MathHtml className="choice-caption" html={choice.html || ''} /> : <div className="choice-caption" dangerouslySetInnerHTML={{__html: choice.html || ''}} />}
                  </Box>
                )}
              />
            </Box>
          </Box>
        )
      })}
    </RadioGroup>
  )
}

function CheckboxChoice ({context, question, choices}) {

  const classes = useStyles()

  const {assessment} = context

  const [selectedOptions, setOptions] = React.useState([])

  React.useEffect(() => {
    if (choices.length > 0) {
      setOptions(choices.filter(c => c.correct).map(c => c.id))
    }
  }, [choices])

  return (
    <FormGroup className={clsx("choices", "checkbox")}>
      {choices.map((option, index) => {
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
        return (
        <Box key={index} className={classes.option}>
          <Box className={classes.checkbox}>
            <FormControlLabel
              control={<Checkbox color="primary" checked={selectedOptions.indexOf(option.id) >= 0} />}
              label={(
                <Box className={classes.optionLabel}>
                  <Box className="index">{answerIndex})</Box>
                  {context.importedMath ? <MathHtml className="choice-caption" html={option.html || ''} /> : <div className="choice-caption" dangerouslySetInnerHTML={{__html: option.html || ''}} />}
                </Box>
              )}
            />
          </Box>
        </Box>
        )})}
    </FormGroup>
  )
}

function multipleChoiceStyles (theme) {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexWrap: 'wrap',
      paddingLeft: 10,
      fontSize: '12pt',
    },
    option: {
      display: 'flex'
    },
    optionLabel: {
      display: 'flex',
      "& > .index": {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginRight: 15
      }
    }
  }
}
